import { useMemo } from 'react';

import { Button } from 'antd';

import { hasPermission } from '../../../helpers/user';

import { PERMISSIONS } from '../../../constants/permissions';

const useEventActions = ({ permissions = [], onAddEventClick }) => {
  return useMemo(() => {
    const availableActions = [];

    if (hasPermission([PERMISSIONS.EVENTS.CREATE], permissions)) {
      availableActions.push({
        label: (
          <Button color="default" size="small" variant="link" onClick={onAddEventClick}>
            Add event
          </Button>
        )
      });
    }

    return availableActions;
  }, [permissions, onAddEventClick]);
};

export default useEventActions;
